import React, { createContext, useContext, useState } from 'react';

export const UnreadCountContext = createContext({
  notificationUnread: 0,
  setNotificationUnread: (count: number) => {},
});

export const useUnreadCount = () => useContext(UnreadCountContext);

export const UnreadCountProvider = ({ children }) => {
  const [notificationUnread, setNotificationUnread] = useState(0);

  return (
    <UnreadCountContext.Provider
      value={{
        notificationUnread,
        setNotificationUnread,
      }}
    >
      {children}
    </UnreadCountContext.Provider>
  );
};
